const s = require("./config.module.scss");

import { default as React, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { MonitoringConfigDto } from "core/backend/common";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const emptyDto: MonitoringConfigDto = { id: 0, page: "", tableName: "", fileType: "", backupFileType: "", spanningFile: "", deadline: "", active: false };

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: MonitoringConfigDto[];
    deleteConfig: (id: number) => void;
    editConfig: (dto: MonitoringConfigDto) => void;
    addConfig: (dto: MonitoringConfigDto) => void;
    pages: string[];
    files: string[];
    readOnly: boolean;
}

const List = ({ t, data, scrollPosition, deleteConfig, editConfig, addConfig, pages, files, readOnly }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const [isAddition, setAddition] = useState(false);
    const [editDto, setEditDto] = useState(emptyDto);

    return (
        <>
            <table id="datatable">
                <thead>
                    <tr>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:page")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:table")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:fileType")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:backupFileType")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:spanningFile")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:deadline")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoringConfig:active")}</th>
                        <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("comonitoringConfignfiguration:actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data && data.map((d) => <Row key={d.id} dto={d} deleteConfig={deleteConfig} editConfig={editConfig} pages={pages} files={files} readOnly={readOnly} />)
                    }
                    {
                        isAddition ? <Row key={emptyDto.id} dto={emptyDto} editDefault={true} cancelEditConfig={() => setAddition(false)} editConfig={x => { setAddition(false); addConfig(x) }} pages={pages} files={files} readOnly={readOnly} /> : null
                    }
                </tbody>
            </table>
            {readOnly === false &&
                <div className={s.addIcon}>
                    <FontAwesomeIcon icon={faPlusSquare} onClick={e => setAddition(true)} />
                </div>
            }
        </>
    );
};

const translated = withTranslation()(List);

export default translated;